// Fisher-Yates shuffle (generic, works on any array)
export function shuffle(array) {
    const arr = array.slice(); // copy so original isn't mutated
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

export function getRandomInArray(array) {
    if (!array || !array.length) return null;
    const idx = Math.floor(Math.random() * array.length);
    return array[idx];
}